import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id B5DC36AC-6F79-4CDE-B1CD-02F221BF8CE4
 * name shield-alert
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-alert.svg
 * tags
 * - Alert / Error 
 */
export const ShieldAlertIcon = createSvgIcon(<><path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5M11,7H13V13H11M11,15H13V17H11" /></>, 'ShieldAlertIcon');
export default ShieldAlertIcon